import { GeckoAssetModelType } from 'types'

// Which workflow should be used when making new tickets
export const ACTIVE_FFS_WORKFLOW_ID = 'ffs-asset-workflow'

// Orgs whose users can create FFS tickets from the inspection inbox
export const FFS_ENABLED_ORGS: ReadonlyArray<string> = ['falcon-6f06dc']

// Asset-model types eligible for FFS ticket creation from the inbox.
export const FFS_ENABLED_ASSET_TYPES: ReadonlyArray<GeckoAssetModelType> = [
  GeckoAssetModelType.Piping,
]
